export default "__VITE_ASSET__CgPoeBW4__"